export class AppModal extends HTMLElement {
    private isOpen: boolean = false;
    private initialContent: string = '';

    constructor() {
        super();
    }

    connectedCallback() {
        // Guardamos el contenido inicial antes de envolverlo con el overlay
        this.initialContent = this.innerHTML;
        this.render();
        this.setupListeners();
        
        // Sincronizar visibilidad inicial
        this.updateVisibility(false);
    }

    static get observedAttributes() {
        return ['modal-id'];
    }

    public open() {
        this.isOpen = true;
        this.updateVisibility(true);
        document.body.style.overflow = 'hidden';
        this.dispatchEvent(new CustomEvent('open', { bubbles: true }));
    }

    public close() {
        this.isOpen = false;
        this.updateVisibility(false);
        document.body.style.overflow = '';
        this.dispatchEvent(new CustomEvent('close', { bubbles: true }));
    }

    private setupListeners() {
        this.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            
            // Cerrar si hace clic en el overlay o en un elemento con data-close-modal
            if (target.id === 'modalOverlay' || target.closest('[data-close-modal]')) {
                this.close();
            }

            // Emitir evento de 'confirm' si hace clic en algo con data-confirm-modal
            if (target.closest('[data-confirm-modal]')) {
                this.dispatchEvent(new CustomEvent('confirm', {
                    bubbles: true,
                    detail: { originalEvent: e }
                }));
            }
        });

        // Escuchar evento global por ID para apertura remota
        const modalId = this.getAttribute('modal-id');
        if (modalId) {
            window.addEventListener(`open-modal-${modalId}`, () => this.open());
            window.addEventListener(`close-modal-${modalId}`, () => this.close());
        }
    }

    private updateVisibility(show: boolean) {
        const overlay = this.querySelector('#modalOverlay');
        const container = this.querySelector('#modalContainer');
        
        if (overlay && container) {
            if (show) {
                overlay.classList.remove('hidden');
                overlay.classList.add('flex');
                // Forzar reflujo para disparar animación si se usa CSS transitions
                requestAnimationFrame(() => {
                    container.classList.remove('scale-95', 'opacity-0');
                    container.classList.add('scale-100', 'opacity-100');
                });
            } else {
                container.classList.add('scale-95', 'opacity-0');
                container.classList.remove('scale-100', 'opacity-100');
                
                // Esperar a que la transición termine antes de ocultar el overlay
                setTimeout(() => {
                    if (!this.isOpen) {
                        overlay.classList.add('hidden');
                        overlay.classList.remove('flex');
                    }
                }, 300);
            }
        }
    }

    render() {
        this.innerHTML = `
            <div id="modalOverlay" class="hidden fixed inset-0 z-[600] items-center justify-center p-4 bg-[#001b3d]/80 backdrop-blur-sm transition-opacity duration-300">
                <div id="modalContainer" class="transform transition-all duration-300 scale-95 opacity-0 w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
                    ${this.initialContent}
                </div>
            </div>

            <style>
                #modalContainer {
                    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.2s ease-out;
                }
                .custom-scrollbar::-webkit-scrollbar { width: 6px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
            </style>
        `;
    }
}

if (typeof window !== 'undefined') {
    customElements.define('app-modal', AppModal);
}
